import React, { FC } from 'react';
import { Card, SectionHeading } from 'components/molecules';
import { CardGrid } from 'components/organisms';
import { ReadMoreTextArea } from 'components/atoms';
import { ScreeningRiskSummary } from './config';
import { ThirdPartyType } from 'types';
import { Risks } from 'components/atoms/risk-rating/types';

interface ScreeningRisksProps {
  adverseRiskNotes?: string;
  adverseRiskScore: Risks;
  regulatoryEnforcementRiskNotes?: string;
  regulatoryEnforcementRiskScore: Risks;
  politicalRiskNotes?: string;
  politicalRiskScore: Risks;
  resolutionNotes?: string;
  watchListRiskNotes?: string;
  watchListRiskScore: Risks;
  type: ThirdPartyType;
}

const ScreeningRisks: FC<ScreeningRisksProps> = ({
  adverseRiskNotes,
  adverseRiskScore,
  regulatoryEnforcementRiskNotes,
  regulatoryEnforcementRiskScore,
  politicalRiskNotes,
  politicalRiskScore,
  resolutionNotes,
  watchListRiskNotes,
  watchListRiskScore,
  type,
}) => {
  const text = resolutionNotes;
  const maxTextLength = 400;
  return (
    <section>
      <SectionHeading text="Screening Findings" />
      <ReadMoreTextArea text={text} maxTextLength={maxTextLength} />
      <CardGrid>
        <Card
          compact={true}
          title="Adverse Media"
          risk={adverseRiskScore || 'Unknown'}
          text={adverseRiskNotes}
          icon="adverseMedia"
          tooltip={ScreeningRiskSummary.AdverseMedia}
        />
        <Card
          compact={true}
          title="Regulatory & Enforcement"
          risk={regulatoryEnforcementRiskScore || 'Unknown'}
          text={regulatoryEnforcementRiskNotes}
          icon="enforcements"
          tooltip={ScreeningRiskSummary.Enforcement}
        />
        <Card
          compact={true}
          title="Political Exposure"
          risk={politicalRiskScore || 'Unknown'}
          text={politicalRiskNotes}
          icon="political"
          tooltip={ScreeningRiskSummary[`PoliticalExposure${type}`]}
        />
        <Card
          compact={true}
          title="Watchlists"
          risk={watchListRiskScore || 'Unknown'}
          text={watchListRiskNotes}
          icon="sanctions"
          tooltip={ScreeningRiskSummary.WatchList}
        />
      </CardGrid>
    </section>
  );
};

export default ScreeningRisks;
